import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { hasReportRouteAccess, hasSectionAccess } from "../../../utils/permissions";

const STOCK_OVERVIEW_PATH = "/report/masterInventoryReport";
const STOCK_ADJUSTMENTS_PATH = "/report/reconciliationReport";

const InventoryManagementSideBar = () => {
  const location = useLocation();
  const user = useSelector((state) => state.auth.user);
  const authProfileData = useSelector((state) => state.auth.profileData);
  const userForPerms =
    user && authProfileData && !user.profileData
      ? { ...user, profileData: authProfileData }
      : user;

  const canAccessPurchase = hasSectionAccess(userForPerms, "purchase");
  const canAccessStockOverview = hasReportRouteAccess(userForPerms, STOCK_OVERVIEW_PATH);
  const canAccessStockAdjustments = hasReportRouteAccess(userForPerms, STOCK_ADJUSTMENTS_PATH);

  const path = (location.pathname || "").toLowerCase();
  const isStockOverviewActive = path.startsWith(STOCK_OVERVIEW_PATH.toLowerCase());
  const isStockAdjustmentsActive = path.startsWith(STOCK_ADJUSTMENTS_PATH.toLowerCase());
  const isPurchaseOrdersActive = path.startsWith("/purchaseorder");
  const isRequisitionsActive = path.startsWith("/requisition");
  const isSuppliersActive = path.startsWith("/supplier");

  const isSectionActive =
    isStockOverviewActive ||
    isStockAdjustmentsActive ||
    isPurchaseOrdersActive ||
    isRequisitionsActive ||
    isSuppliersActive;

  const hasAnyVisibleItem =
    canAccessStockOverview ||
    canAccessPurchase ||
    canAccessStockAdjustments;

  if (!hasAnyVisibleItem) return null;

  return (
    <div className={`menu-item has-sub ${isSectionActive ? "active" : ""}`}>
      <div className="menu-link">
        <div className="menu-icon">
          <i className="fa fa-boxes"></i>
        </div>
        <div className="menu-text">Inventory Management</div>
        <div className="menu-caret"></div>
      </div>
      <div className="menu-submenu">
        {canAccessStockOverview && (
          <div className={`menu-item ${isStockOverviewActive ? "active" : ""}`}>
            <NavLink to={STOCK_OVERVIEW_PATH} className="menu-link">
              Stock Overview
            </NavLink>
          </div>
        )}

        {canAccessPurchase && (
          <div className={`menu-item ${isPurchaseOrdersActive ? "active" : ""}`}>
            <NavLink to="/purchaseOrder/managePurchaseOrders" className="menu-link">
              Purchase Orders
            </NavLink>
          </div>
        )}

        {canAccessStockAdjustments && (
          <div className={`menu-item ${isStockAdjustmentsActive ? "active" : ""}`}>
            <NavLink to={STOCK_ADJUSTMENTS_PATH} className="menu-link">
              Stock Adjustments
            </NavLink>
          </div>
        )}

        {canAccessPurchase && (
          <div className={`menu-item ${isRequisitionsActive ? "active" : ""}`}>
            <NavLink to="/requisition/manageRequisitions" className="menu-link">
              Requisitions
            </NavLink>
          </div>
        )}

        {canAccessPurchase && (
          <div className={`menu-item ${isSuppliersActive ? "active" : ""}`}>
            <NavLink to="/Supplier/manageSupplier" className="menu-link">
              Suppliers
            </NavLink>
          </div>
        )}
      </div>
    </div>
  );
};

export default InventoryManagementSideBar;
